export default "__VITE_ASSET__DSCcAWv8__"